import vrcolorsBanner from '../images/banners/vrcolors.png';
import alleyBanner from '../images/banners/theAlley.png';
import kareBanner from '../images/banners/KAREproject.png';

const svgIconElements = {
	github: (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 inline mr-2" viewBox="0 0 24 24">
				<path
					fill="currentColor"
					d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33c.85 0 1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2Z"
				/>
			</svg>
		</>
	),
	chain: (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 inline mr-2">
				<path d="M12.232 4.232a2.5 2.5 0 013.536 3.536l-1.225 1.224a.75.75 0 001.061 1.06l1.224-1.224a4 4 0 00-5.656-5.656l-3 3a4 4 0 00.225 5.865.75.75 0 00.977-1.138 2.5 2.5 0 01-.142-3.667l3-3z" />
				<path d="M11.603 7.963a.75.75 0 00-.977 1.138 2.5 2.5 0 01.142 3.667l-3 3a2.5 2.5 0 01-3.536-3.536l1.225-1.224a.75.75 0 00-1.061-1.06l-1.224 1.224a4 4 0 105.656 5.656l3-3a4 4 0 00-.225-5.865z" />
			</svg>
		</>
	),
};

export const vrcolorsData = {
	title: 'VRColors',
	description: (
		<>
			A theme creation and sharing website for VRChat built using <span className="text-indigo-300 font-semibold">modern React principles</span>. I created a cache
			system using <span className="text-indigo-300 font-semibold">Cloudflare Workers</span> to reduce the generation time of thumbnails{' '}
			<span className="text-amber-300 font-semibold">from 1150ms to 50ms</span>. A significant focus of the app was user experience. This was developed by{' '}
			<span className="text-indigo-300 font-semibold">conducting user interviews</span>, adjusting the design and clarifying features based on the feedback
			receieved.
		</>
	),
	tools: ['React', 'Tailwind CSS', 'Express', 'Cloudflare', 'Node.js'],
	links: [
		{
			label: 'Live Site',
			href: 'https://vrcolors.app',
			icon: svgIconElements['chain'],
		},
		{
			label: 'Source Code',
			href: 'https://github.com/loganhalverson/vrcolors',
			icon: svgIconElements['github'],
		},
	],
	banner: vrcolorsBanner,
};

export const kareData = {
	title: 'KARE Project',
	description: (
		<>
			Medical software developed by a team of <span className="font-semibold text-indigo-300">nine developers</span> for my college capstone course. The purpose of
			KARE is to help parents of medically complex children care for them in a domestic environment. I was responsible for the{' '}
			<span className="font-semibold text-indigo-300">mobile development and design</span> of the software, along with gathering and clarifying requirements from
			the client. I acted as the <span className="font-semibold text-indigo-300">scrum master</span> for the mobile team, ensuring our development went smoothly.
		</>
	),
	tools: ['React Native', 'Expo GO', 'LAMP Stack'],
	links: [
		{
			label: 'Presentation',
			href: 'https://docs.google.com/presentation/d/1XarBl_QDAfMsQfs9jbCJ5wgOAwlmfGGLSa14Xk8ef8A/edit#slide=id.g24bd759f86a_1_363',
			icon: svgIconElements['chain'],
		},
	],
	banner: kareBanner,
};

export const alleyData = {
	title: 'The Alley',
	description: (
		<>
			A simple website for a local music venue. Developed as my first project with <span className="text-indigo-300 font-semibold">Tailwind</span>, it was a way
			for me to learn the library and create something for a place I loved.
		</>
	),
	tools: ['HTML5', 'Tailwind CSS'],
	links: [
		{
			label: 'Live Site',
			href: 'https://regal-cactus-f42c40.netlify.app/',
			icon: svgIconElements['chain'],
		},
		{
			label: 'Source Code',
			href: 'https://github.com/loganhalverson/the-alley',
			icon: svgIconElements['github'],
		},
	],
	banner: alleyBanner,
};

export const albireoData = {
	title: 'Albireo Energy',
	timespan: 'Full-time, February 2024 –',
	location: 'Redmond, Washington, United States',
	position: 'Project Integrator II',
	description: (
		<>
			A simple website for a local music venue. Developed as my first project with <span className="text-indigo-300 font-semibold">Tailwind</span>, it was a way
			for me to learn the library and create something for a place I loved.
		</>
	),
	tools: ['HTML5', 'Tailwind CSS'],
	links: [
		{
			label: 'Company Website',
			href: 'https://regal-cactus-f42c40.netlify.app/',
			icon: svgIconElements['chain'],
		},
		{
			label: 'Source Code',
			href: 'https://github.com/loganhalverson/the-alley',
			icon: svgIconElements['github'],
		},
	],
	banner: alleyBanner,
};